import { BRAND_WORDMARK_ACCENT, BRAND_WORDMARK_BASE } from "@/lib/brand";
import { cn } from "@/lib/cn";

import { Logo } from "./Logo";

type WordmarkProps = {
  className?: string;
  /** Use the primary brand tile for the mark (top-bar treatment) instead of the bare mark. */
  tile?: boolean;
};

export function Wordmark({ className, tile = true }: WordmarkProps) {
  return (
    <span className={cn("inline-flex items-center gap-2.5 font-sans font-semibold", className)}>
      <Logo size={26} className="text-foreground" tile={tile} />
      <span className="text-base tracking-tight text-foreground">
        {BRAND_WORDMARK_BASE}
        <span className="text-primary">{BRAND_WORDMARK_ACCENT}</span>
      </span>
    </span>
  );
}
